/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Next_AriaInputs */

const en_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Event`)
};

const fr_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement suivant`)
};

const de_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Veranstaltung`)
};

const it_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo evento`)
};

const ru_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующее событие`)
};

const es_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

const zh_cn2_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个活动`)
};

const ja_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベント`)
};

const hi_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली घटना`)
};

const pt_pt2_video_export_preview_next_aria = /** @type {(inputs: Video_Export_Preview_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

/**
* | output |
* | --- |
* | "Next Event" |
*
* @param {Video_Export_Preview_Next_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_next_aria = /** @type {((inputs?: Video_Export_Preview_Next_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Next_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_next_aria(inputs)
	if (locale === "de") return de_video_export_preview_next_aria(inputs)
	if (locale === "it") return it_video_export_preview_next_aria(inputs)
	if (locale === "ru") return ru_video_export_preview_next_aria(inputs)
	if (locale === "es") return es_video_export_preview_next_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_next_aria(inputs)
	if (locale === "ja") return ja_video_export_preview_next_aria(inputs)
	if (locale === "hi") return hi_video_export_preview_next_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_next_aria(inputs)
	return en_video_export_preview_next_aria(inputs)
});